var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      { staticClass: "text-center border border-bottom-0 border-gray-500" },
      _vm._l(_vm.tabs, function ({ item: { name, title }, isActive }) {
        return _c(
          "div",
          {
            staticClass: "d-inline-block w-50 cursor-pointer",
            class: { "bg-white": isActive, "bg-gray-500": !isActive },
            on: {
              click: function ($event) {
                return _vm.onSelect(name)
              },
            },
          },
          [
            _c("div", { staticClass: "pt-2 pb-2" }, [
              _c("h6", {
                staticClass: "mb-0",
                domProps: { textContent: _vm._s(title) },
              }),
            ]),
          ]
        )
      }),
      0
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "border border-top-0 border-gray-500 p-2" },
      [
        _c(
          "div",
          [
            _vm.active === "chat"
              ? _c("chat-component", {
                  staticClass: "d-flex flex-column",
                  staticStyle: { height: "550px" },
                  attrs: {
                    conversation: _vm.conversation,
                    "index-media-url": _vm.indexMediaUrl,
                    "can-create-media": _vm.canCreateMedia,
                    "store-media-url": _vm.storeMediaUrl,
                    "can-send-message": _vm.canSendMessage,
                    types: _vm.types,
                  },
                })
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        _vm.active === "groups"
          ? _c("send-list-manager", {
              attrs: { url: _vm.url },
              on: { change: _vm.onSendListsChange },
            })
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }